export const handleSetLocalStorage = (key: string, language: string) => {
  localStorage.setItem(key, language);
};

export const handleGetLocalStorage = (key: any) => {
  return localStorage.getItem(key);
};

export const formatMoney = (money: number) => {
  return Number(money).toLocaleString("vi-VN", {
    style: "currency",
    currency: "VND",
  });
};

export const convertToVietnamTime = (dateString: string): string => {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    // weekday: "long", // Thứ (ví dụ: Thứ Hai)
    year: "numeric", // Năm (ví dụ: 2024)
    month: "long", // Tháng (ví dụ: Tháng 10)
    day: "numeric", // Ngày (ví dụ: 23)
    // hour: "2-digit", // Giờ (ví dụ: 10)
    // minute: "2-digit", // Phút (ví dụ: 48)
    // second: "2-digit", // Giây (ví dụ: 45)
    // hour12: false, // Sử dụng định dạng 24 giờ
    timeZone: "Asia/Ho_Chi_Minh", // Múi giờ Việt Nam
  };

  return new Intl.DateTimeFormat("en-EN", options).format(date);
};

export function getStartEndOfCurrentMonth(): { start: string; end: string } {
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const startOfMonth = new Date(year, month, 1);
  startOfMonth.setDate(startOfMonth.getDate() + 1);

  const endOfMonth = new Date(year, month + 1, 0); // Ngày cuối cùng của tháng là ngày 0 của tháng sau
  endOfMonth.setDate(endOfMonth.getDate() + 1);

  const startDate = startOfMonth.toISOString().split("T")[0]; // Lấy phần ngày tháng năm từ định dạng ISO
  const endDate = endOfMonth.toISOString().split("T")[0]; // Lấy phần ngày tháng năm từ định dạng ISO

  return { start: startDate, end: endDate };
}

export function getStartEndOfAnyMonth(
  year: number,
  month: number
): { start: string; end: string } {
  const startOfMonth = new Date(year, month - 1, 1);
  startOfMonth.setDate(startOfMonth.getDate() + 1);

  const endOfMonth = new Date(year, month, 0);
  endOfMonth.setDate(endOfMonth.getDate() + 1);

  const startDate = startOfMonth.toISOString().split("T")[0];
  const endDate = endOfMonth.toISOString().split("T")[0];

  return { start: startDate, end: endDate };
}

export function formatToVND(value: number | string | null | undefined): string {
  // Kiểm tra giá trị đầu vào, nếu null hoặc undefined, trả về chuỗi rỗng
  if (value === null || value === undefined) {
    return "";
  }

  // Chuyển giá trị thành số
  const numberValue = typeof value === "string" ? parseFloat(value) : value;

  // Kiểm tra nếu không phải là số hợp lệ
  if (isNaN(numberValue)) {
    throw new Error("Giá trị không hợp lệ. Hãy nhập số hoặc chuỗi số.");
  }

  // Sử dụng `toLocaleString` để định dạng tiền tệ Việt Nam
  return numberValue.toLocaleString("vi-VN", {
    currency: "VND",
  });
}

export function formatNumberWithCommas(num: any) {
  // Convert the number to a string
  let numStr = num.toString();

  // Find the position to insert the comma
  let result = "";
  let count = 0;

  // Iterate from the end of the string
  for (let i = numStr.length - 1; i >= 0; i--) {
    result = numStr[i] + result; // Append character
    count++;

    // Insert comma after every 3 digits (except the last group)
    if (count === 3 && i !== 0) {
      result = "," + result;
      count = 0;
    }
  }

  // Add trailing zeros for thousands
  return result;
}

export function formatMonthDate(inputDate: any) {
  // Tách chuỗi ngày theo định dạng "YYYY-MM-DD"
  const parts = inputDate.split("-");

  // Lấy tháng (phần thứ 2) và ngày (phần thứ 3)
  const month = parts[1];
  const day = parts[2];

  // Trả về chuỗi theo định dạng "MM-DD"
  return `${month}-${day}`;
}
